import defaultMuiTheme from './default';
const props = defaultMuiTheme.props ? { ...defaultMuiTheme.props } : {};
props.MuiAppBar = {
    color: 'default',
    elevation: 0,
    position: 'fixed',
};
props.MuiButton = {
    variant: 'contained',
};
props.MuiExpansionPanel = {
    elevation: 0,
    square: true,
};
props.MuiFilledInput = {
    disableUnderline: true,
};
props.MuiListItemText = {
    disableTypography: true,
};
props.MuiInput = {
    disableUnderline: true,
};
export default props;
//# sourceMappingURL=props.js.map